import * as angular from "angular";
import { LeagueHandler } from "./LeagueHandler";
import { LeaguesResource } from "./LeaguesResource";
import { RankingResource } from "./RankingResource";
import { MatchService } from "./MatchService";
import { LeagueMatchResource } from "./LeagueMatchResource";

export let playServiceEslApi = angular.module("play.service.api.eslapi", ["ngResource"]);

playServiceEslApi.service("LeagueHandler", LeagueHandler);
playServiceEslApi.service("LeaguesResource", LeaguesResource);
playServiceEslApi.service("MatchServiceOld", MatchService);
playServiceEslApi.factory("RankingResource", RankingResource);
playServiceEslApi.service("LeagueMatchResource", LeagueMatchResource);

export * from "./LeagueHandler";
export * from "./LeaguesResource";
export * from "./RankingResource";
export * from "./MatchService";
